module.exports = __webpack_public_path__ + "static/media/hp_02.4c957a80.jpg";